export default __webpack_public_path__ + "static/media/650.de43edcc.png";